module.exports = __webpack_public_path__ + "img/chgvehic.07b8b8a7.webp";